// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--1jBgt","container--disabled":"a10a3f92e9--container--disabled--1NjYD","text":"a10a3f92e9--text--cwJhy"};